import styled, { css } from 'styled-components';
import { MenuItem } from '@higo/ui';

export const HeaderNotificationMenuFooterMenuItem = styled(MenuItem)(
  ({ theme }) => css`
    color: ${theme.palette.primary['600']};
    text-align: center;
  `,
);
